/**
 * Right-side slide-in panel used by Overview drill-downs.
 * Shows: small eyebrow text, big title, body HTML.
 * The caller passes `onMount(panelEl)` for chart instantiation
 * after the HTML is in the DOM.
 */

let inited = false;
let activeChartIds = [];   // chart canvas IDs the panel currently owns

function lazyInit() {
  if (inited) return;
  inited = true;
  document.getElementById('drill-close').addEventListener('click', closeDrillPanel);
  document.getElementById('overlay').addEventListener('click', closeDrillPanel);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrillPanel();
  });
}

export function openDrillPanel({ eyebrow, title, html, chartIds = [], onMount }) {
  lazyInit();
  document.getElementById('drill-eyebrow').textContent = eyebrow || '';
  document.getElementById('drill-title').textContent   = title   || '';
  const body = document.getElementById('drill-body');
  body.innerHTML = html;

  document.getElementById('drill-panel').classList.add('open');
  document.getElementById('overlay').classList.add('visible');

  activeChartIds = chartIds;

  if (typeof onMount === 'function') {
    // Defer one tick so Chart.js can size against rendered DOM
    setTimeout(() => onMount(body), 30);
  }
}

export function closeDrillPanel() {
  document.getElementById('drill-panel').classList.remove('open');
  document.getElementById('overlay').classList.remove('visible');
  // Destroy any chart.js instances by canvas id (caller owns Chart instances
  // but panel owns lifecycle — caller stashes them on window.__drillCharts).
  for (const id of activeChartIds) {
    const c = window.__drillCharts?.[id];
    if (c) { try { c.destroy(); } catch {} delete window.__drillCharts[id]; }
  }
  activeChartIds = [];
}
